import React, { useContext } from 'react';
import LanguageContext from '../contexts/LanguageContext';
import { translations } from '../translations';

const Solution = () => {
  const { language } = useContext(LanguageContext);
  const t = translations[language];

  return (
    <section className="bg-white py-20 md:py-28">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <span className="inline-block mb-4 text-sm font-bold uppercase tracking-widest text-indigo-600">
          {t.solution.label}
        </span>
        <h2 className="text-3xl md:text-5xl font-bold text-slate-900 mb-6 leading-tight">
          {t.solution.title}
        </h2>
        <p className="text-lg md:text-xl text-slate-600 max-w-3xl mx-auto leading-relaxed mb-8">
          {t.solution.subtitle}
        </p>

        <div className="max-w-3xl mx-auto rounded-2xl bg-gradient-to-br from-indigo-600 to-violet-700 text-white p-8 md:p-10 shadow-xl mb-8">
          <p className="text-xl md:text-2xl font-semibold leading-relaxed">
            {t.solution.highlight}
          </p>
        </div>

        <p className="text-base md:text-lg text-slate-500 max-w-2xl mx-auto leading-relaxed italic">
          {t.solution.description}
        </p>
      </div>
    </section>
  );
};

export default Solution;
